import { ConfigService } from '@services/config/config.service';
import { tap } from 'rxjs/operators';

export function initGTM(configService: ConfigService): () => Promise<any> {
  return (): Promise<any> => {
    return configService
      .getConfig()
      .pipe(
        tap(() => {
          updateGTMID(configService.getArrayProperty('GTM_ID'));
          const node = document.createElement('link');
          document.getElementsByTagName('head')[0].appendChild(node);
        })
      )
      .toPromise();
  };
}

export function updateGTMID(gtmId: Array<string>): void {
  gtmId.map((singleGtmId) => {
    addGTMID(singleGtmId);
  });
}

export function addGTMID(gtmId: string | boolean): void {
  const SCRIPT_NODE = document.createElement('script');
  SCRIPT_NODE.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');`;
  document.getElementsByTagName('head')[0].appendChild(SCRIPT_NODE);
}
